import { Grid, Paper, Tab, Tabs } from "@mui/material";
import React from "react";

import TabLabel from "components/pages/transmissions/tabs/label/TabLabel";
import useTransmissionTab from "components/pages/transmissions/tabs/useTransmissionTab";
// import TransmissionTableYearlyFilter from "components/pages/transmissions/filter/yearly_filter/TransmissionTableYearlyFilter";

const TransmissionTabs = ({ isLoading, role, view, tabStyles }) => {
  const { tabs, onTabChange } = useTransmissionTab(role, tabStyles);

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          {view && (
            <Paper
              square
              elevation={0}
              style={{
                position: "relative",
                top: "1px",
                zIndex: 1000,
                backgroundColor: "transparent",
              }}
            >
              <Tabs
                onChange={(_event, value) => {
                  isLoading === false && view !== value && onTabChange(value);
                }}
                value={view}
                indicatorColor="secondary"
                TabIndicatorProps={{ style: { top: 0, borderBottom: "none" } }}
                textColor="secondary"
              >
                {tabs.map(
                  ({ label, value, totalCount, scope, style }, index) =>
                    scope.includes(role) && (
                      <Tab
                        key={index}
                        disabled={isLoading}
                        style={style && style}
                        value={value}
                        sx={{ fullWidth: true }}
                        label={<TabLabel label={label} count={totalCount} />}
                      />
                    )
                )}
              </Tabs>
            </Paper>
          )}
        </Grid>
        {/* <Grid item>
          <TransmissionTableYearlyFilter />
        </Grid> */}
      </Grid>
    </>
  );
};

export default TransmissionTabs;
